import React, { useState, useRef } from 'react';
import { DataObjectContainer } from '../dataObjects/DataObjectContextManager';
import { BoundTextbox, BoundDropdownList, PageableList } from '../dataObjects/BoundControls';
import { Popup } from '../core/Popup';
import { XSquare } from 'react-feather';
import { Card } from '../core/Card';

export const CategoryPage = () => {

    const context = useRef(null);
    const popup = useRef(null);
    const list = useRef(null);

    const onSaved = async () => {
        list.current.refresh();
    }

    return (
        <Card title='Categories' subtitle='The following categories are available for translations and images'>     
            <Popup ref={popup}>
                <NewCategoryPopupContent popup={popup} onSaved={onSaved} />
            </Popup>

            <DataObjectContainer ref={context} dataObjectName={'categoryDataObject'} >

                <button className='btn btn-primary' onClick={() => { popup.current.show(); }}>New</button>

                <PageableList pageSize={20} ref={list}
                    onRenderHeaderRow={() => {
                        return (
                            <div className='row caption' >
                                <div className='cell mobile-hidden'>Client Id</div>
                                <div className='cell'>Name</div>
                                <div className='cell mobile-hidden'>User</div>
                            </div>
                        )
                    }}
                    onRenderRow={(key, item, references) => {
                        return (
                            <div className='row' key={`row${key}`}>
                                <div className='cell mobile-hidden'>{key}</div>
                                <div className='cell'>{item.name}</div>
                                <div className='cell mobile-hidden'>{item.createUser}</div>
                            </div>
                        )
                    }} />

            </DataObjectContainer>
        </Card>
    );
}


export const NewCategoryPopupContent = ({ popup, onSaved }) => {

    const context = useRef(null);
    const [valid, setValid] = useState(false);

    const onSaveClick = async () => {
        popup.current.close();
        var response = await context.current.submitAsync();
        if (onSaved) {
            onSaved(response);
        }
    }

    return (
        <DataObjectContainer ref={context} dataObjectName={'categoryDataObject'} onValidated={valid => { setValid(valid) }} >
            <div className='topSection'>
                <div className='left'></div>
                <div className='center'><h4>New Category</h4></div>
                <div className='right'><XSquare className='icon btn-close clickable' onClick={() => { popup.current.close() }} /></div>
            </div>

            <div className='contentSection'>
                <label htmlFor='name'>Name</label>
                <BoundTextbox propertyName={'name'} />
            </div>

            <div className='footerSection'>
                <button className='btn btn-primary btn-modal' onClick={() => { popup.current.close(); }}>Cancel</button>
                <button className='btn btn-secondary btn-modal' disabled={!valid} onClick={onSaveClick}>Save</button>
            </div>
        </DataObjectContainer>
    );
}